import { BaseEntity } from './shared/baseEntity';

export const Topic = ({
  code,
  name_en,
  name_de,
  name_fr,
  description_en,
  description_de,
  description_fr,
  category,
  questionIds,
  benchmarkBaseValue,
  id,
  isActive
}) => {
  return Object.assign({
    code,
    name_en,
    name_de,
    name_fr,
    description_en,
    description_de,
    description_fr,
    category,
    questionIds,
    benchmarkBaseValue
  },
  BaseEntity(id, isActive));
};



// WEBPACK FOOTER //
// ./src/models/topic.js